<template>
  <div class="card card-padded">
    <slot />
  </div>
</template>

<script>
export default { name: 'UICard' }
</script>

<style scoped>
</style>


